module.exports = __webpack_public_path__ + "static/media/rating.a74c3e63.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/SSP/rating.png
// module id = 64
// module chunks = 0